import React from 'react'
import UserTable from '../components/users page/user table/UserTable'

const UserTablePageMain = () => {
  return (
    <div>
        <UserTable/>
    </div>
  )
}

export default UserTablePageMain
